import React from "react";
import classNames from "classnames";
import { useIcon } from "../../../assets/useIcon";
import "./SeemaOK.scss";

interface SeemaOKProps {
  className?: string;
  isLarge?: boolean;
}

export const SeemaOK: React.FC<SeemaOKProps> = ({
  className = "",
  isLarge = false,
}) => {
  const { getSvg } = useIcon();

  return (
    <div
      className={classNames("seema-wrap", { "is-large": isLarge }, className)}
    >
      <div className="seema-success-wrap">
        <div
          className="seema-face"
          style={{ backgroundImage: `url("${getSvg("girl_face_success")}")` }}
        />
        <div
          className="seema-twiches"
          style={{ backgroundImage: `url("${getSvg("girl_thumb_twiches")}")` }}
        />
        <div
          className="seema-thumb"
          style={{ backgroundImage: `url("${getSvg("girl_thumb")}")` }}
        />
      </div>
    </div>
  );
};

export default SeemaOK;
